import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppUpdateService } from '../../services/app-update/app-update.service';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';
import { FEATURE_FLAGS } from '../../constants/feature-flags.constants';

@Component({
  selector: 'lib-app-update-banner',
  imports: [TranslocoPipe],
  templateUrl: './app-update-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateBannerComponent implements OnInit {
  private readonly appUpdateService = inject(AppUpdateService);
  readonly featureFlagService = inject(FeatureFlagsService);

  readonly newVersionBanner = computed(() =>
    this.featureFlagService.getFeatureFlagValue(
      FEATURE_FLAGS.SYSTEM.new_version_banner
    )
  );

  showNewVersionButton = computed(() =>
    this.appUpdateService.showNewVersionButton()
  );

  ngOnInit(): void {
    this.appUpdateService.checkForUpdates();
  }

  hardRefresh(): void {
    this.reloadPage();
    this.appUpdateService.showNewVersionButton.set(false);
  }

  // Protected for testability
  protected reloadPage(): void {
    location.reload();
  }
}
